import addPopover from "../dom/addPopover";

export default function addChainstitchPopOver() {
	addPopover(
		"Chainstitch",
		".pplr-chain-stitch-20",
		"CHAIN STITCH",
		'<img src="https://cdn.shopify.com/s/files/1/0324/9592/7429/files/Chainstitch.gif?v=1664827534" width="153" height="117" style="width:100%" />',
	);
}
